import React from 'react';

import Access from 'ui/Access';
import PageTabs from 'ui/PageTabs';
import { getToday, relativeToday } from 'utils/date-utils';
import { withAppContext } from '../AppContext';

import { EventLog, UserActivity, PasswordAudit } from './tabs';
import { DatePickerInput } from 'ui/datepicker';

const TAB_LIST = [
    {
        name: 'user_activity',
        label: 'User Activity',
        access: Access.REPORTS_USER_ACTIVITY,
        component: UserActivity,
    },
    {
        name: 'event_log',
        label: 'Event Log',
        access: Access.REPORTS_EVENT_LOG,
        component: EventLog,
    },
    {
        name: 'password_auditing',
        label: 'Password Auditing',
        access: Access.REPORTS_PASSWORD_ACTIVITY,
        component: PasswordAudit,
    },
];

const defaultDateRange = {
    from: relativeToday(-30),
    to: getToday(),
    enteredTo: getToday(),
    selectedType: {
        type: 'last_30_days',
        title: 'Last 30 days',
    },
};

class Reports extends React.Component {
    state = {
        tabs: [],
        dateRange: defaultDateRange,
    };

    componentDidMount() {
        const { updateBreadcrumbs } = this.props;
        updateBreadcrumbs(['Reports']);
        this.updateTabs();
    }

    updateTabs(cb) {
        const { app } = this.props;
        const accessFilter = tab => app.canView(tab.access);
        const tabs = TAB_LIST.filter(accessFilter);
        this.setState({ tabs }, cb);
    }

    findTab(num) {
        const { tabs } = this.state;
        return tabs[num] || tabs[0];
    }

    handleDateChange = dates => {
        this.setState({
            dateRange: dates,
        });
    };

    render() {
        const { tabs, dateRange } = this.state;
        const { app, history } = this.props;
        return (
            <PageTabs
                tabs={tabs.map(tab => tab.label)}
                darkBackground={[3]}
                headerContent={
                    <DatePickerInput
                        onDateChange={this.handleDateChange}
                        range={defaultDateRange}
                    />
                }
            >
                {value => {
                    const tab = this.findTab(value);
                    if (!tab) {
                        return null;
                    }
                    const ComponentTab = tab.component;
                    return (
                        <ComponentTab
                            dateRange={dateRange}
                            history={history}
                            organization={app.currentUser.organizations[0].uuid}
                            editable={app.canChange(tab.access)}
                            app={app}
                        />
                    );
                }}
            </PageTabs>
        );
    }
}

export default withAppContext(Reports);
